// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__p+xNq","tab":"Tabs_tab__G361I","tooltip":"Tabs_tooltip__4BP9R","count":"Tabs_count__WYllO","active":"Tabs_active__8C+hh"};